import React, { PureComponent, Fragment } from "react";

import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";

import { PIE_COLORS, StandardTooltip, selectFormat, Error } from "./../../../Utils/Utils.js";

const renderName = (name) => {
  const names = {
    desktop: "Desktop",
    mobile: "Mobile",
    fb_app: "Facebook In-App",
    fb_instant: "Facebook Instant",
    amp: "Google AMP"
  };
  return names[name];
};

class WhereTheyWatched extends PureComponent {
  constructor(props) {
    super(props);
    this.renderCell = this.renderCell.bind(this);
  }

  renderCell = (entry, index) => <Cell key={index} fill={PIE_COLORS[index % PIE_COLORS.length]} />;

  renderPercentage() {
    const { data } = this.props;
    const total = data.graph.reduce((s, e) => s + e.value, 0);
    const sorted = data.graph.sort((a, b) => a.value - b.value);
    sorted.reverse();

    return sorted.map((e, key) => {
      if (((e.value * 100) / total).toFixed(0) > 0) {
        // prevent 0%
        return (
          <div className="col-6 text-left mb-1" key={e.name}>
            <span className="pr-1" style={{ color: PIE_COLORS[key % PIE_COLORS.length] }}>
              {((e.value * 100) / total).toFixed(0)}%
            </span>
            <span>{renderName(e.name)}</span>
          </div>
        );
      } else {
        return null;
      }
    });
  }

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const total = data.graph.reduce((s, e) => s + e.value, 0);

    return (
      <Fragment>
        <div className="row mb-3 pt-3 pt-lg-0">
          <ResponsiveContainer height={200}>
            <PieChart>
              <Pie data={data.graph} dataKey="value" innerRadius="70%" outerRadius="100%">
                {data.graph.map(this.renderCell)}
              </Pie>

              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    total={total}
                    render={({ data }) => {
                      const payload = data(data.graph);

                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Where They Viewed
                              </span>
                            </header>

                            <main className="standard-tooltip__main">
                              {Object.keys(payload)
                                .sort((a, b) => payload[a].value - payload[b].value)
                                .filter((key) => payload[key].value > 0)
                                .map((key) => (
                                  <Fragment key={key}>
                                    <div className="standard-tooltip__item" key={"item1"}>
                                      <span
                                        className="standard-tooltip__key"
                                        style={{ color: payload[key].color }}
                                      >
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: payload[key].payload.fill
                                          }}
                                        />
                                        {renderName(payload[key].payload.name)}
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {((payload[key].payload.value * 100) / total).toFixed(0)}% (
                                        {selectFormat("number", payload[key].payload.value)})
                                      </span>
                                    </div>
                                  </Fragment>
                                ))}
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="row justify-content-left">{this.renderPercentage()}</div>
      </Fragment>
    );
  }
}

export default WhereTheyWatched;
